export function enforcePrimarySort(columnId, defaultDesc = false) {
  return (sortingState) => {
    const primary = { id: columnId, desc: defaultDesc }
    const secondary = sortingState.filter((s) => s.id !== columnId).at(-1)

    return secondary ? [primary, secondary] : [primary]
  }
}

/**
 * @param {import("@tanstack/react-table").SortingState} sortingState
 * @param {string} primaryColumnId
 * @returns {import("../../types/table.types").CSVExportSortingConfig}
 */
export function getSecondarySortValue(sortingState, primaryColumnId) {
  const secondarySort = sortingState
    .filter((s) => s.id !== primaryColumnId)
    .at(-1)

  if (!secondarySort) {
    return {
      sortField: null,
      sortOrder: null,
    }
  }

  return {
    sortField: secondarySort.id,
    sortOrder: secondarySort.desc ? "desc" : "asc",
  }
}

/**
 * @param {import("@tanstack/react-table").SortingState} sortingState
 * @returns {import("../../types/table.types").CSVExportSortingConfig}
 */
export function getPrimarySortValue(sortingState) {
  const primarySort = sortingState[0]
  if (!primarySort) {
    return {
      sortField: null,
      sortOrder: null,
    }
  }

  return {
    sortField: primarySort.id,
    sortOrder: primarySort.desc ? -1 : 1,
  }
}
